import React, { useState } from "react";
import axios from "axios";

export const useRegisterUser = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [resData, setResData] = useState(null);

  // calling api for user registration
  const registerUser = async (userData) => {
    setLoading(true);
    setError(null);
    setResData(null);

    try {
      const response = await axios.post(
        // "http://localhost:3535/api/v1/auth/registerMember",
        "https://api.v2vbn.org:8443/api/v1/auth/registerMember",
        userData,
        {
          headers: {
            "Content-Type": "multipart/form-data", // Important!
          },
        }
      );
      console.log(response);
      setResData(response.data);
    } catch (err) {
      setError(err.response ? err.response.data : "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return { loading, error, resData, registerUser };
};
